angular.module('gym.workouts').controller('WorkoutsOptInCtrl', ["$scope", "$rootScope", "$state", "$window", "Workouts", "FreeTrialRemindMessageText", "GTMService", "FeatureNamesService", function($scope, $rootScope, $state, $window, Workouts, FreeTrialRemindMessageText, GTMService, FeatureNamesService) {
  var billingPageUrl;
  $scope.isFeatureEnabled = !!_.find($rootScope.gym.features_enabled, function(feature) {
    return feature === 'workouts';
  });
  GTMService.trackPage('Workouts toggle');
  $scope.memberPortalLabel = FeatureNamesService.memberPortal({
    divider: 'or'
  });
  $scope.optIn = function() {
    GTMService.trackPage('Workouts toggle', "Let's get started");
    return Workouts.all('workouts').doPOST({}, 'opt_in').then(function() {
      var url;
      url = $state.href('gym.workouts.list');
      return $window.open(url, '_self');
    });
  };
  billingPageUrl = $state.href('gym.subscription.tab', {
    tab: 'subscriptions'
  });
  $scope.getRemindMessageText = FreeTrialRemindMessageText.get('Accelerating or Established', billingPageUrl);
  return $scope.isFreeTrialRemindMessageAvailable = $rootScope.gym.on_trial_period && $rootScope.gym.trialling_highest_plan;
}]);
